import { faChevronCircleLeft, faChevronCircleRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export const Navigators = (props:any) => {
    const [t] = useTranslation();
    const { navigatorIds, navigatorData, manageStateChange } = props;
    const currentUrl = window.location.href;
    const navigate = useNavigate();

    const checkIfFirst = () => {
        if (!navigatorIds || navigatorIds.length === 0) return true;
        const currentId = currentUrl.split("/").slice(-1)[0];
        return navigatorIds && navigatorIds.length > 0 && currentId == navigatorIds[0];
    }

    const checkIfLast = () => {
        if (!navigatorIds || navigatorIds.length === 0) return true;
        const currentId = currentUrl.split("/").slice(-1)[0];
        return navigatorIds && navigatorIds.length > 0 && currentId == navigatorIds[navigatorIds.length - 1];
    }

    const getTrimmedUrl = () => {
        const unwrapped = currentUrl.replace(/^\[.*?\]\((.*?)\)$/, '$1');
        const withoutBase = unwrapped.replace(/^[a-zA-Z]+:\/\/[^/]+/, '');
        const trimmed = withoutBase.replace(/\/\d+$/, '');
        return trimmed;
    }

    const navigatePrevious = () => {
        const currentId = currentUrl.split("/").slice(-1)[0];
        const currentIndex = navigatorIds.findIndex((id:any) => id == currentId);
        if (currentIndex > 0) {
            const tempUrl = getTrimmedUrl();
            navigate(tempUrl + `/${navigatorIds[currentIndex - 1]}`);
            manageStateChange(navigatorData.find((data:any) => data.id == navigatorIds[currentIndex - 1]));
        }
    }

    const navigateNext = () => {
        const currentId = currentUrl.split("/").slice(-1)[0];
        const currentIndex = navigatorIds.findIndex((id:any) => id == currentId);
        if (currentIndex < navigatorIds.length - 1) {
            const tempUrl = getTrimmedUrl();
            navigate(tempUrl + `/${navigatorIds[currentIndex + 1]}`);
            manageStateChange(navigatorData.find((data:any) => data.id == navigatorIds[currentIndex + 1]));
        }
    }

    return (
        <Box>
            <Tooltip title={t("PREVIOUS_STANDARD")} arrow>
            <IconButton color="info" disabled={checkIfFirst()} onClick={() => {navigatePrevious()}}>
                <FontAwesomeIcon width="24px" icon={faChevronCircleLeft} />
            </IconButton>
            </Tooltip>
            <Tooltip title={t("NEXT_STANDARD")} arrow>
            <IconButton disabled={checkIfLast()} color="info" onClick={() => {navigateNext()}}>
                <FontAwesomeIcon width="24px" icon={faChevronCircleRight} />
            </IconButton>
            </Tooltip>
        </Box>
    )
}